<template>
<div class="p-1 pb-10">
        <h1 class="text-xs text-center w-full font-bold">隐私政策（摘要）</h1>
        <h2 class="text-justify font-bold mb-2">广州心与潮信息科技有限公司（以下简称：“心潮科技”）尊重并保护所有使用小睡眠移动客户端的用户（以下称为“您”）个人隐私与信息安全。本摘要将帮助您直观、简明地了解心潮科技如何收集、存储、使用、管理和保护您的个人信息的相关事宜。更多详细信息请阅读完整的<a @click="$router.push('/privacy')">《小睡眠隐私信息保护政策》</a></h2>
        <h2 class="text-justify font-bold mb-2">（一）小睡眠 App 所收集的信息</h2>
        <div class="box mb-3">
            <p>1. 服务内容展示/浏览/播放/下载功能</p>
            <p><span>使用目的：</span>正常使用服务内容展示/浏览/播放/下载功能，识别帐号异常状态用途。</p>
            <p><span>收集范围：设备序列号、设备型号、操作系统、唯一设备标识符、IP地址、操作日志、MAC地址、Android_ID、匿名设备标识符(OAID)、设备运行进程信息、应用程序安装列表信息、获取应用安装列表、获取设备传感器、蓝牙地址、读取设备IP。</span></p>
        </div>
        <div class="box mb-3">
            <p>2. 日志信息</p>
            <p><span>使用目的：</span>帮助我们优化产品服务。</p>
            <p><span>收集范围：</span>搜索和浏览记录、关注、播放记录、访问量、播放时长、IP地址、WiFi网络、使用的语言、访问日期和时间。</p>
        </div>
        <div class="box mb-3">
            <p>3. 创建帐号功能</p>
            <p><span>使用目的：</span>完成注册程序，提供专属于注册用户的产品或服务。</p>
            <p><span>收集范围：手机号码、</span>用户名。</p>
        </div>
        <div class="box mb-3">
            <p>4. 第三方帐号信息</p>
            <p><span>使用目的：</span>用于提供帐号登录服务以及保障帐号安全，防范安全风险。</p>
            <p><span>收集范围：</span>您使用第三方平台的帐号头像、昵称或ID。</p>
        </div>
        <div class="box mb-3">
            <p>5. 基本资料维护&身份验证</p>
            <p><span>使用目的：</span>维护您的基本资料，改善您的服务体验。</p>
            <p><span>收集范围：</span>性别、所在地、头像、昵称、生日。</p>
        </div>
        <div class="box mb-3">
            <p>6. 上传或发布信息功能</p>
            <p><span>使用目的：</span>确保内容安全、避免可疑的上传帐号对我方平台用户和受众的打扰，净化网络空间。</p>
            <p><span>收集范围：手机号码。</span></p>
        </div>
        <div class="box mb-3">
            <p>7. 消息通知与定向推送</p>
            <p><span>使用目的：</span>通过“消息通知”的方式向您提供或推广我们的商品和服务。</p>
            <p><span>收集范围：浏览、搜索及播放记录、设备信息、位置信息、订单信息。</span></p>
            <p><span>关闭说明：</span>您可通过<span>“我的-系统设置-个性化内容推荐”</span>自主选择关闭定向推送功能。</p>
        </div>
        <div class="box mb-3">
            <p>8. 记录睡眠功能</p>
            <p><span>使用目的：</span>用于运行记录睡眠算法功能，检测您的设备电量偏低时，记录睡眠算法会自动停止，以节省您的设备耗电；分析您的睡眠质量以及检测梦话、呼噜声。</p>
            <p><span>申请权限：允许录音权限、允许存储权限。</span></p>
        </div>
        <div class="box mb-3">
            <p>9. 宁静空间功能</p>
            <p><span>使用目的：</span>运行周围环境噪音分析算法，以提供给您可以屏蔽周围噪音的服务。</p>
            <p><span>申请权限：允许录音权限。</span></p>
        </div>
        <div class="box mb-3">
            <p>10. 心跳实验功能</p>
            <p><span>使用目的：</span>运行心率变化分析算法，以提供给您符合当下心情的内容推荐服务。</p>
            <p><span>申请权限：允许相机权限。</span></p>
        </div>
        <div class="box mb-3">
            <p>11. 您参加运营和互动活动</p>
            <p><span>使用目的：</span>若您参加运营活动所领取的<span>红包进行提现，</span>或奖品需要寄送。</p>
            <p><span>收集范围：身份证信息、</span>地址信息、小睡眠昵称、头像、相册图片。</p>
            <p><span>申请权限：访问相册、存储权限。</span></p>
        </div>
        <div class="box mb-3">
            <p>12. 为您提供会员、声音卡、宝宝卡或订阅服务</p>
            <p><span>使用目的：</span>完成会员、声音卡、宝宝卡费用支付、退款、活动红包提现、解除连续订阅服务、售后服务。</p>
            <p><span>收集范围：</span>订单信息，包括购买会员、声音卡、充值睡贝的信息。</p>
        </div>
        <div class="box mb-3">
            <p>13. 客户服务及争议处理</p>
            <p><span>使用目的：</span>提供客户服务。</p>
            <p><span>收集范围：交易、支付信息。</span></p>
        </div>
        <div class="box mb-3">
            <p>14.安全保障功能</p>
            <p><span>使用目的：</span>保障您使用我们的产品或服务时的帐号与系统安全。</p>
            <p><span>收集范围：个人常用设备信息（包含：硬件型号、设备MAC地址、IMEI、IMSI）、 登录IP地址、产品版本号、浏览记录、服务故障信息，以及个人敏感信息：手机号码、交易信息。</span></p>
        </div>
        <div class="box mb-3">
            <p>15.闹钟唤醒功能</p>
            <p><span>使用目的：</span>实现闹钟唤醒的服务体验。</p>
            <p><span>申请权限：</span>自启动与关联启动。</p>
            <p><span>关闭说明：</span>在手机设置 - 应用管理 - 应用权限中，关闭小睡眠的自启动与关联启动的权限。</p>
        </div>
        <div class="box mb-3">
            <p>16.粘贴复制功能</p>
            <p><span>使用目的：</span>文字聊天、发表评论、内容复制。</p>
            <p><span>收集范围：</span>粘贴板文字内容。</p>
            <p><span>申请权限：</span>识别粘贴板（剪贴板、剪切板）。</p>
        </div>
        <div class="box mb-3">
            <p>17. 传感器应用场景</p>
            <p><span>使用目的：</span>满足广告功能的业务需求。</p>
            <p><span>申请权限：</span>加速度传感器、重力传感器、陀螺仪传感器、旋转矢量传感器、光线传感器，调用设备传感器。</p>
        </div>
        <div class="box mb-3">
            <p>18. 社区发布梦话服务</p>
            <p><span>使用目的：</span>内容上传或提供至平台。</p>
            <p><span>收集范围：</span>您主动上传并分享的梦话/呼噜/神秘音。</p>
        </div>
        <div class="box mb-3">
            <p>19. 社区发布梦境服务</p>
            <p><span>使用目的：</span>内容上传或提供至平台。</p>
            <p><span>收集范围：</span>您主动上传分享并分享的梦境文字。</p>
        </div>
        <h2 class="text-justify font-bold mb-2">（二）如何了解与管理个人信息</h2>
        <div class="box">
            <p>1.我们为您提供了便捷的已收集个人信息查看通道，您可以直接查阅<a @click="$router.push('/personal-infomation-list')">《已收集个人信息清单》</a>进行了解。</p>
            <p>2.基于您向我们提供的信息、我们可能收集的信息及我们通过间接方式收集到的您的信息，<span>例如您的浏览、搜索及播放记录、设备信息、位置信息、订单信息，我们可能会基于上述一项或几项信息的结合，进行推荐算法建模、程序化广告推荐算法建模、用户行为分析及用户画像，用于提取您的浏览、搜索偏好、行为习惯、位置信息相关特征，以便向您提供更契合您需求的页面展示和推荐个性化内容。您可通过“我的-系统设置-个性化内容推荐”</span>自主选择关闭定向推送功能。</p>
            <p>3.如果您希望访问或编辑您的帐号中的个人基本资料信息、或注销您的帐号，您可以登录帐号通过“帐号与资料”执行此类操作。我方已通过技术方式实现，使您可以自行在“注销帐号”页面（小睡眠移动客户端“我的 - 帐号与资料 - 注销帐号”）提交帐号注销申请。若未能申请成功，您也可联系我方客服。我们在核实用户身份后，会注销您的手机号和使用记录，达到注销的效果。</p>
        </div>
        <h2 class="text-justify font-bold mb-2">（三）第三方 SDK 所收集的信息</h2>
        <p>您授权同意我们可能委托授权合作伙伴为您提供某些服务或代表我们履行职能，我们仅会出于本隐私信息保护政策声明的合法、正当、必要、特定、明确的目的共享您的信息，授权合作伙伴只能接触到为其履行职责所需信息，且不得将此信息用于其他任何目的。您可以通过阅读<a @click="$router.push('/infomation-share-list')">《第三方信息共享清单》</a>了解更多详细信息。</p>
        <h2 class="text-justify font-bold mb-2">（四）如何联系心潮科技公司</h2>
        <p>您可以通过以下方式与我们联系，我们将在15个工作日内回复您的请求。</p>
        <p>我们设立了个人信息保护专职部门，如您对心潮科技隐私信息保护政策、儿童个人信息有任何疑问、意见或建议，您可通过以下方式与我们取得联系：</p>
        <p><span>我方地址：</span>广州市海珠区新滘中路10号之三101、之四101、之五101</p>
        <p><span>联系人：</span>心潮科技客服部</p>
        <p><span>联系方式：</span>020-87351934</p>
        <p><span>联系邮箱：</span>office@heartide.com</p>
    </div>
</template>

<script>
export default {
    data(){
        return {

        }
    },
    created(){

    },
    mounted(){

    },
    methods:{

    },
}
</script>

<style lang='scss' scoped>
h2{
    font-size: px2html(16px);
}


.box{
    
    p{
        &:first-child{
            font-weight: bolder;
            font-size: px2html(16px);
        }
    }
    
}
p{
    text-align: left;
    margin-bottom: px2html(5px);
    span{
        font-weight: bold;
    }
}
a{
    color: rgb(8,124,255);
    text-decoration: underline;
}
</style>